export default __webpack_public_path__ + "static/media/20-7.14fd5e69.mp3";